export const SET_ASYNC_DATA = 'SET_ASYNC_DATA';
export const SET_LOADING = 'SET_LOADING';